<template>
  <div id="main">
    <div class="container">
      <div class="panel">
        <div class="panel-header">
          <h2>{{ $t('设置新密码') }}</h2>
        </div>
        <div class="panel-body">
          <div class="page-status success">
            <div class="icon">
              <i class="iconfont icon-check-circle" />
            </div>
            <div class="content">
              <h3>{{ $t('恭喜你！新密码设置成功') }}</h3>
            </div>
            <div class="action">
              <button class="button-plain" @click="close">{{ $t('去登录') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'success',
  data() {
    return {}
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    close() {
      if (window.isInApp) {
        window.bridge.toJDCloudLogin('forgetPwd')
      } else {
        const { returnUrl } = this.$route.query
        if (returnUrl) {
          window.open(`//login.jdcloud.com/jdcloudLogin?returnUrl=${returnUrl}`, '_self')
          return
        }
        window.open('//login.jdcloud.com/jdcloudLogin', '_self')
      }
    }
  }
}
</script>
